var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSourceUtils } from '../../shared/utils/data-source-utils';
import { of } from 'rxjs';
var IvrTableDataSource = /** @class */ (function (_super) {
    __extends(IvrTableDataSource, _super);
    function IvrTableDataSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IvrTableDataSource.prototype.update = function () { };
    IvrTableDataSource.prototype.onConnect = function () {
        return of([[{ position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' }], 1]);
    };
    return IvrTableDataSource;
}(DataSourceUtils));
export { IvrTableDataSource };
